import { Box, Grid, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { groupBy, map } from 'lodash';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { io } from 'socket.io-client';
import { getTranslatedValue } from 'src/common/utils/format-utils';
import { REACT_APP_IO_URL } from 'src/constants/base';
import { useAuth } from 'src/hooks';
import { Page } from '../page';
import { AttestationApplicantCard } from './attestation-applicant-card';

const socket = io(REACT_APP_IO_URL + '/api/socket/attestation', {
  reconnectionDelayMax: 10000,
  transports: ['websocket'],
  autoConnect: false,
  auth: { token: '' },
});

export const Attestation: ComponentType = () => {
  const [data, setData] = useState([]);
  const { t, i18n } = useTranslation();
  const { user } = useAuth();

  const token = localStorage.getItem('AUTH_TOKEN_KEY');

  useEffect(() => {
    if (token) {
      //@ts-ignore
      socket.auth.token = token;

      socket.connect();
      socket.on('connect', () => {
        console.log('connected');
      });
      socket.on('disconnect', () => {
        console.log('disconnected');
      });

      socket.on('applicants', (data: any) => {
        setData(data);
      });

      return () => {
        socket.disconnect();
      };
    }
  }, [token]);

  const groupedData = groupBy(data, 'attestationDate');

  const content = data.length ? (
    map(groupedData, (items: Record<string, any>, dateGroup) => {
      return (
        <Box mt={6} key={dateGroup}>
          <Typography variant="subtitle1" mb={2}>
            {format(new Date(dateGroup), 'HH:mm dd.MM.yyyy')}
          </Typography>
          <Grid container spacing={1.5}>
            {items.map((item: any) => {
              return (
                <Grid item xs={12} sm={6} key={item.id}>
                  <AttestationApplicantCard application={item} />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      );
    })
  ) : (
    <>
      <Stack alignItems="center" mt={3}>
        <img src="/assets/illustr_attestation.svg" alt="waiting..." width="500" height="500" />
        <Typography variant="h2" color="primary">
          {t('attestation.list.available', 'Список аттестуемых будет доступен в день аттестации')}
        </Typography>
      </Stack>
    </>
  );

  return (
    <Page title={t('attestation', 'Аттестация')}>
      <Typography variant="subtitle1" mt={-1}>
        {user.data && getTranslatedValue(user.data.location?.name, i18n.language)}
      </Typography>
      {content}
    </Page>
  );
};
